module.exports = __webpack_public_path__ + "media/images/icon/navigation/portfolio-active-8d7f6595f05678db8f37678b89e778ea.svg";